<template>
  <div class="sticky top-0 z-30 flex h-16 w-full justify-center bg-opacity-90 backdrop-blur transition-all duration-100 bg-base-100 text-base-content">
    <div class="navbar shadow-sm">
      <div class="flex-none">
        <label for="my-drawer-menu" class="btn btn-square btn-ghost drawer-button lg:hidden">
          <hero-icon name="menu" class="h-5 w--5"/>
        </label>
      </div>
      <div class="flex-1 pl-5">
        <div class="form-control w-full max-w-xs">
          <input
            v-model="text"
            id="textsearch"
            name="Search"
            autocomplete="false"
            type="text"
            placeholder="Хайх.."
            class="input input-ghost w-full max-w-xs bg-base-200"
            @keydown.enter="handleSearchCustomer"
          >
        </div>
      </div>
      <div class="flex-none">
        <my-button type="ghost" square icon="plus" title="Шинээр гэрээ бүртгэх" @click="handleCreate()"></my-button>
        <div class="dropdown dropdown-end" id="cog-menu">
          <label tabindex="0" class="btn btn-ghost rounded-btn focus:bg-base-300">
            <hero-icon name="cog" />
          </label>
          <ul class="p-2 shadow-xl menu dropdown-content bg-base-200 rounded-box w-56 mt-4">
            <li><router-link to="/profile"><hero-icon name="user" />Хувийн мэдээлэл</router-link></li>
            <li><router-link to="/password"><hero-icon name="key" />Нууц үг солих</router-link></li>
            <li>
              <a href="#" @click="change_mode">
                <label class="swap swap-rotate">
                  <input type="checkbox" :checked="darkMode" @change="change_mode">
                  <div class="swap-on">
                    <svg class="fill-current w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"/></svg>
                  </div>
                  <div class="swap-off">
                    <svg class="fill-current w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z"/></svg>
                  </div>
                </label>
                <span v-if="darkMode">Өдрийн горим</span>
                <span v-else>Шөнийн горим</span>
              </a>
            </li>
            <li></li>
            <li><a href="#" @click="is_logout(true)"><hero-icon name="logout" />Гарах</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      text: ''
    }
  },
  computed: {
    ...mapGetters(['darkMode'])
  },
  methods: {
    ...mapActions(['is_logout', 'customer_text', 'customer_contracts', 'change_mode']),
    handleCreate () {
      this.$router.push({ name: 'contracts-detail', params: { name: 'all', id: 'create' } })
    },
    async handleSearchCustomer () {
      try {
        let customer = null
        if (this.text.length === 10) {
          customer = await this.customer_contracts(this.text)
        } else {
          customer = await this.customer_text(this.text)
        }
        this.$router.push({ name: 'contracts-detail', params: { id: 'create' }, query: { id: customer.id } })
      } catch (err) {
        this.handleError(err)
      }
    }
  }
}
</script>
